import gql from "graphql-tag";
const ENABLE_TWOFA = gql`
  mutation enable2fa($enable2faInput: Enable2faDto!) {
    enable2fa(enable2faInput: $enable2faInput) {
        success,
        message,
        err
    }
  }
`;

export default ENABLE_TWOFA;
